import { EngineService } from './engine.service';
import { TimerangeModel } from './models/animation/timerange.model';
import { plainToClass } from 'class-transformer';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "./engine.service";
var AnimationService = /** @class */ (function () {
    function AnimationService(engineService) {
        this.engineService = engineService;
    }
    AnimationService.prototype.getChapterLocalTimerange = function (chapterId) {
        var chapter = Human.timeline.activeRoot._chapters.find(function (_chapter) { return _chapter.id === chapterId; });
        return plainToClass(TimerangeModel, chapter.timeRange);
        // Human.timeline.activeRoot._nowBranch;
        // get branch timeline:               <branch>.getTimeframe()
        // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
        // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  
    };
    AnimationService.prototype.mapGlobalTimeToLocal = function (time) {
        return Human.timeline.activeRoot.mapGlobalTime(time).time;
    };
    AnimationService.prototype.mapLocalTimeToGlobal = function (chapterId, time) {
        var branch = Human.timeline.activeRoot._chapters.find(function (chapter) { return chapter.id === chapterId; });
        return Human.timeline.activeRoot.mapBranchTime(branch, time);
    };
    AnimationService.prototype.isChapterAnimated = function (chapter) {
        var isAnimated = chapter.timelineMap
            .filter(function (timeline) {
            return _.get(timeline, 'data.timeline') !== 'dummy' &&
                _.get(timeline, 'data.timeline.id') !== 'dummy';
        }).length > 0;
        return isAnimated;
    };
    AnimationService.prototype.scrub = function (time, which) {
        if (which === void 0) { which = 'first'; }
        Human.timeline.scrub({
            time: time,
            borderCondition: {
                which: which,
                direction: 'forward'
            }
        });
    };
    AnimationService.prototype.play = function (options) {
        Human.timeline.play({ startChapterId: options.chapterId, numChapters: 1, loop: options.loop });
    };
    AnimationService.prototype.unpause = function () {
        Human.timeline.unpause();
    };
    AnimationService.prototype.pause = function () {
        Human.timeline.pause();
    };
    AnimationService.ngInjectableDef = i0.defineInjectable({ factory: function AnimationService_Factory() { return new AnimationService(i0.inject(i1.EngineService)); }, token: AnimationService, providedIn: "root" });
    return AnimationService;
}());
export { AnimationService };
